import React, { PureComponent } from 'react';

/**
 * Style.
 */
import './landing-section.scss';

class LandingSection extends PureComponent {
  render() {
    const {
      children,
      className,
      reference,
      ...rest
    } = this.props;

    return (
      <div className={`landing-section ${className}`} ref={reference} {...rest}>
        {children}
      </div>
    );
  }
}

export default LandingSection;
